import { defineStore, acceptHMRUpdate } from 'pinia';

const store = defineStore('dependencies', {
  state: () => ({
    draggingLink: null,
  }),
  actions: {
    addDependency(sourceEl, targetEl, isSuccessor, delay, type) {
      const elDependencies = sourceEl.getDependencies()?.slice() || []; // dependencies is mutable but items are not
      const newTargetDependencies = targetEl.getDependencies()?.slice() || []; // dependencies is mutable but items are not
      let index = elDependencies.findIndex(item => item.target_id == targetEl.id);
      if (index > -1) {
        if (delay == undefined) delay = elDependencies[index].delay; // preserve existing delay if already exists
        elDependencies.splice(index, 1);
      }
      index = newTargetDependencies.findIndex(item => item.target_id == sourceEl.id);
      if (index > -1) newTargetDependencies.splice(index, 1);

      elDependencies.push({ target_id: targetEl.id, successor: isSuccessor, delay: delay || 0, ...(type ? { type } : {}) });
      sourceEl.setDependencies(elDependencies);
      newTargetDependencies.push({ target_id: sourceEl.id, successor: ! isSuccessor, delay: delay || 0, ...(type ? { type } : {}) });
      targetEl.setDependencies(newTargetDependencies);
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
